import styled from 'styled-components';
import { Align } from 'ui/icons';
import { useFlowChart } from 'ui/workflows/flowchart';
import { IconButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { RightTooltip } from 'ui/tooltip';
import { colors } from 'ui/theme';

export const ALIGN_ALL_TILES_TEST_ID = 'align-all-tiles';

const StyledButton = styled(IconButton)`
  stroke: none;
  && {
    path {
      stroke: none !important;
    }
    :hover {
      path {
        stroke: none !important;
        fill: ${colors.purple90};
      }
    }
  }
`;

type AlignAllTilesButtonProps = {
  /** Callback when "Align tiles" is clicked */
  onAlignNodes: (modalProps: any) => void;
};

export const AlignAllTilesButton = ({ onAlignNodes }: AlignAllTilesButtonProps) => {
  const { relayout } = useFlowChart();
  return (
    <RightTooltip tooltipContent="Align connected tiles">
      <StyledButton
        data-test={ALIGN_ALL_TILES_TEST_ID}
        onClick={() => onAlignNodes({ alignNodes: relayout })}
        size={BUTTON_SIZES.MEDIUM}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        <Align height={20} width={20} color={colors.textSecondary} />
      </StyledButton>
    </RightTooltip>
  );
};
